var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsEyeOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.988 7.98c7.874 0 15.077 4.133 18.61 10.722l.29.568a10.761 10.761 0 0 1 1.08 4.69c0 1.396-.295 2.812-.872 4.188l-.233.515c-3.385 6.88-10.79 11.277-18.915 11.277-7.887 0-15.095-4.147-18.62-10.744l-.283-.553A10.656 10.656 0 0 1 3.94 23.92c0-.154.016-.3.045-.44l.037-.14.044-.525c.088-.787.266-1.57.533-2.349l.218-.583.265-.599C8.443 12.384 15.847 7.98 23.988 7.98zm0 4c-6.644 0-12.634 3.563-15.277 8.984l-.207.47A6.849 6.849 0 0 0 8 24l-.012.225-.028.181.037.382c.075.573.224 1.132.445 1.665l.178.396.252.493c2.8 5.24 8.639 8.598 15.076 8.598 6.631 0 12.628-3.56 15.297-8.983l.184-.405c.353-.844.539-1.736.539-2.592 0-1.017-.231-2.02-.659-2.906l-.253-.493c-2.806-5.233-8.64-8.581-15.068-8.581zm5.334 6.045.326.311a8.004 8.004 0 0 1 .306 11.005l-.302.32c-3.14 3.113-8.202 3.113-11.322-.007-3.142-3.142-3.142-8.213-.002-11.326a7.989 7.989 0 0 1 10.994-.303zm-8.17 3.135a3.987 3.987 0 0 0 .006 5.666c1.56 1.56 4.098 1.56 5.672 0a4 4 0 0 0 .233-5.398l-.255-.276a3.99 3.99 0 0 0-5.656.008z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsEyeOn);
export default __webpack_public_path__ + "static/media/icons-eye-on.c655741aa58abace1e50bf3976b42958.svg";
export { ForwardRef as ReactComponent };